import { useBurn } from './factoryHooks'
import { useDeposit as useVaultDeposit } from './vaultHooks'
import { shouldUseValutContract } from '@/utils'
import { SupportedTicker } from '@/constants/token'

const useDeposit = (ticker: SupportedTicker, options?: { onSuccess?: () => void }) => {
  const burnRequest = useBurn({
    onSuccess: () => {
      options?.onSuccess?.()
    },
  })

  const vaultDepositRequest = useVaultDeposit({
    onSuccess: () => {
      options?.onSuccess?.()
    },
  })

  if (shouldUseValutContract(ticker)) {
    return vaultDepositRequest
  } else {
    return burnRequest
  }
}

export default useDeposit
